export const searchConstants = {
    //send search request
    SEARCH_BITE_REQUEST: 'SEARCH_BITE_REQUEST',
    SEARCH_BITE_SUCCESS: 'SEARCH_BITE_SUCCESS',
    SEARCH_BITE_FAILURE: 'SEARCH_BITE_FAILURE',

    SEARCH_TOPIC_REQUEST: 'SEARCH_TOPIC_REQUEST',
    SEARCH_TOPIC_SUCCESS: 'SEARCH_TOPIC_SUCCESS',
    SEARCH_TOPIC_FAILURE: 'SEARCH_TOPIC_FAILURE',
};